import React from 'react'
import PageMeta from '../../components/common/PageMeta'
import PageBreadcrumb from '../../components/common/PageBreadCrumb'
import ComponentCard from '../../components/common/ComponentCard'
import PropertiesTable from './table/propertiesTable'

const PropertiesPage = () => {
  return (
    <>
    <PageMeta
        title="121 properties"
        description="This is React.js Basic Tables Dashboard page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Properties Tabel" />
      <div className="space-y-6 overflow-hidden max-w-full">
        <ComponentCard title="Properties">
          <PropertiesTable />
        </ComponentCard>
      </div>
    </>
  )
}

export default PropertiesPage